export default {
  memberList: () => import('./memberList/index.vue'), // 会员列表
  newMember: () => import('./newMember/index.vue'), // 新建会员
  memberDetail: () => import('./memberDetail/index.vue'), // 会员详情
  labelSet: () => import('./labelSet/index.vue'), // 标签设置
  smsPurchase: () => import('./smsPurchase/index.vue'), // 短信购买
  smsRecord: () => import('./smsRecord/index.vue'), // 消息记录
  couponRecord: () => import('./couponRecord/index.vue'), // 优惠券记录
};
